import { takeLatest } from "redux-saga/effects";

import {
  FIND_IFLOW_TASKS_BY_FILTERS,
  UPDATE_READFLAG,
} from "../ducks/tasks/actionTypes";

import { findIflowTasksByFilters, updateReadFlag } from "../ducks/tasks/sagas";

export const tasksSagas = [
  takeLatest(FIND_IFLOW_TASKS_BY_FILTERS, findIflowTasksByFilters),
  takeLatest(UPDATE_READFLAG, updateReadFlag),
];
